module.exports = __webpack_public_path__ + "static/media/cerveja-me-2.b05bb7e6.jpg";